import React, { useEffect, useRef, useState } from 'react'
import { useFormContext, useFieldArray, FormProvider, useForm } from 'react-hook-form'
import { SelectInput, useTranslate, TextInput, required } from 'react-admin'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { Button, Checkbox, InputLabel, Skeleton, Table, TableBody, TableCell, TableFooter, TableHead, TablePagination, TableRow, TextField, Typography } from '@mui/material'
import { DatePickers } from 'src/components/uiElements/react-hook-fields'
import { operationTypeServices } from 'src/services/payment/operationType/operationType.service'
import { accountServices } from 'src/services/payment/account/account.service'
import { SplitByCharacterWithPosition } from 'src/helper/splitByCharacter'
import { usePaymentContext } from 'src/components/pages/payment/payment/context/paymentContext'
import { parseDateFormat } from 'src/helper/parseDateFormat'
import { MultiAutocompleteInput } from 'src/components/uiElements/fields/MultiAutocompleteInput'
import { numberFormatterWithDecimalAndThousand } from 'src/helper/numberFormatterWithDecimalAndThousand'
import { NumberInput } from 'src/components/uiElements/fields/NumberInput'

const AmountInput = ({allSelected, index, setValue, field, getValues}) =>{
  const translate = useTranslate()
  const [isChecked, setIsChecked] = useState(false)
  const validateAmountToUse = (amount_to_use, formData, data) => {
    let total_amount = formData?.credit?.[index]?.amount_pending
    if (amount_to_use > total_amount) {
      return translate('ra.message.validate_amount_to_use')
    }
  }

  useEffect(()=>{
    setIsChecked(
      field.amount_pending === field.amount_to_pay ||
      field.amount_pending === getValues(`credit.${index}.amount_to_pay`)
    )
  },[field])

  useEffect(()=>{
   setIsChecked(allSelected)
  },[allSelected])

  useEffect(()=>{
    setTotalValue(isChecked)
  },[isChecked])

  const setTotalValue = (checked) =>{
    if(checked){
      setValue(`credit.${index}.amount_to_pay`, field.amount_pending)
    } else /* if(getValues(`credit.${index}.amount_to_pay`) === 0) */{
      setValue(`credit.${index}.amount_to_pay`, 0)
    }
  }
  return(
    <>
      <TableCell style={{width:'20%'}}>
        <div className='editInputsWrap' style={{minHeight:'auto'}}>
          <NumberInput
            label={false}
            source={`credit.${index}.amount_to_pay`}
            helperText={false}
            fullWidth
            thousandSeparator="."
            decimalSeparator=","
            fixedDecimalScale={false}
            validate={validateAmountToUse}
          />
        </div>
      </TableCell>
      <TableCell style={{width:'20%'}}>
        <Checkbox
            onChange={(e)=>{
              const checked = e.target.checked
              setIsChecked(checked)
            
            }}
            checked={isChecked}
            value={isChecked}
          />
      </TableCell>
    </>
  )
}

export const CreditArray = ({ selectedBusinessUnit }) => {
  const translate = useTranslate()
  const { control, setValue, getValues } = useFormContext()
  const [loading, setLoading] = useState(false)
  const [operationTypes, setOperationTypes] = useState(false)
  const [creditsLoading, setCreditsLoading] = useState([])
  const [allSelected, setAllSelected] = useState(false)
  const [paginationItemData, setPaginationItemData] = useState({ page: 0, rowsPerPage: 10 })
  const { setPaymentCredit, currency } = usePaymentContext()
  const {
    fields: creditFields,
    replace,
    update
  } = useFieldArray({
    control,
    name: 'credit',
  })

  const [partialCredits, setPartialCredits] = useState(creditFields.length > 10 ? creditFields.slice(0, 10) : creditFields)

  const initialCreditFieldsRef = useRef(null);
  const [reserveOptions, setReserveOptions] = useState()
  useEffect(() => {
    if (!initialCreditFieldsRef.current && creditFields.length > 0) {
      initialCreditFieldsRef.current = JSON.parse(JSON.stringify(creditFields));
      setReserveOptions(JSON.parse(JSON.stringify(creditFields)))
    }
  }, [creditFields]);

  const auxForm = useForm({})

  useEffect(()=>{
    setAllSelected(false)
  },[paginationItemData.page])

  useEffect(()=>{
    if(allSelected){
      for(let index = paginationItemData.page; index < paginationItemData.page * paginationItemData.rowsPerPage; index++){
        setValue(`credit.${index}.amount_to_pay`, creditFields[index].amount_pending)
      }
      
    } else {
      for(let index = paginationItemData.page; index < paginationItemData.page * paginationItemData.rowsPerPage; index++){
        setValue(`credit.${index}.amount_to_pay`, 0)
      }
    }
  },[allSelected])

  const onPageItemChange = (number) => {
    const paginationItemDataAux = { ...paginationItemData }
    paginationItemDataAux.page = number
    setPartialCredits(
      creditFields.length > paginationItemData.rowsPerPage ? 
      creditFields.slice(number*paginationItemData.rowsPerPage, number*paginationItemData.rowsPerPage + paginationItemData.rowsPerPage) : 
      creditFields
    )
    setPaginationItemData(paginationItemDataAux)
  }

  const onRowsPerPageItemChange = (e) => {
    const paginationItemDataAux = { ...paginationItemData }
    paginationItemDataAux.rowsPerPage = parseInt(e.target.value, 10)
    paginationItemDataAux.page = 0
    setPartialCredits(
      creditFields.length > paginationItemData.rowsPerPage ? 
      creditFields.slice(paginationItemDataAux.page, paginationItemDataAux.rowsPerPage) : 
      creditFields
    )
    setPaginationItemData(paginationItemDataAux)
  }

  const formatCredits = (listCredit) =>
    listCredit?.map((credit) => {
      return {
        operation_type: credit?.operation_type_relation?.id,
        currency: credit?.currency_relation?.hash_currency,
        date_time: credit?.date_time,
        amount_pending: credit?.amount_pending,
        amount_to_pay: 0,
        id: credit?.id,
        name: credit?.name,
        hash_reservation: credit?.hash_reservation,
      }
    })

  useEffect(()=>{
    setPartialCredits(
      creditFields.length > paginationItemData.rowsPerPage ? 
      creditFields.slice(paginationItemData.page*paginationItemData.rowsPerPage, paginationItemData.page*paginationItemData.rowsPerPage + paginationItemData.rowsPerPage) : 
      creditFields
    )
  },[creditFields])  

  useEffect(() => {
    getOperationType()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    getCredits()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getValues('currency')])

  const getOperationType = async () => {
    try {
      setLoading(true)
      const options = await operationTypeServices.getByAll()
      if (options.length) {
        setOperationTypes(options)
        setLoading(false)
        return
      }
      setOperationTypes([])
      setLoading(false)
    } catch (error) {
      setOperationTypes([])
      setLoading(false)
    }
  }

  const getCredits = async () => {
    try {
      setCreditsLoading(true)
      const options = await accountServices.getCreditsByBusinessUnitId(
        selectedBusinessUnit?.hash_business_unit,
        currency?.hash_currency
      )
      if (options.length !== 0) {
        const credits = formatCredits(options)
        setValue('credit', credits)
        setPaymentCredit(credits)
        setCreditsLoading(false)
        return
      }
      setCreditsLoading(false)
      setPaymentCredit([])
    } catch (error) {
      setPaymentCredit([])
      setCreditsLoading(false)
    }
  }

  const uniqueByNameCreditArray = Object.values(
    reserveOptions?
    reserveOptions.reduce((acc, obj) => {
      acc[obj.name] = obj;
      return acc;
    }, {}):
    []
  );

  const searchReserves = async (reserve, length = 2) => {
      let searchTimeout
        clearTimeout(searchTimeout)
    
        searchTimeout = setTimeout(async () => {
            const reservaOptions = reserve?.name?.toLowerCase().split(',')
            const reservesAux = initialCreditFieldsRef.current?.filter(rsv => 
              reservaOptions.some(opt => opt && rsv.name?.toLowerCase().includes(opt))
            )
            setReserveOptions(reservesAux)
        }, 1000)
      }

  return (
    <>
      {creditsLoading ? (
        <Skeleton variant='rectangular' width={'100%'} height={60} />
      ) : creditFields?.length === 0 && !creditsLoading ? (
        <Typography id='modal-modal-title' variant='h6' component='h3' margin={'20px'}>
          {translate('ra.message.no_have_credits')}
        </Typography>
      ) : (
        <>
        <FormProvider {...auxForm}>
          <MultiAutocompleteInput
            source='choice'
            options={uniqueByNameCreditArray}
            loading={creditsLoading}
            optionsText={['name']}
            multiple
            style={{width:'50%', marginBottom:'15px'}}
            optionValue='id'
            onSearch={searchReserves}
            resetOnLoad={false}
            fields={['name']}
            onChange={(e) => {
              if(e.target.value){
                /* setSelectedCredits(e.target.value?.map(credit=>credit.name)) */
                const names = e.target.value?.map(credit=>credit.name)
                if(names.length > 0){
                  replace(initialCreditFieldsRef.current?.filter(credit=>names.includes(credit.name)))
                } else {
                  replace(initialCreditFieldsRef.current)
                }
                
              }
            }}
            disablePortal={false}
          />
          </FormProvider>
        
        <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  {translate('ra.field.reserve')}
                </TableCell>
                <TableCell>
                  {translate('ra.field.date')}
                </TableCell>
                <TableCell>
                  {translate('ra.field.amount')}
                </TableCell>
                <TableCell>
                  {translate('ra.field.amount_to_use')}
                </TableCell>
                <TableCell>
                  {translate('ra.field.total')}
                  <Checkbox
                    value={allSelected}
                    checked={allSelected}
                    onChange={()=>{
                      setAllSelected(prev=>!prev)
                    }}
                  />
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {React.Children.toArray(
                partialCredits.map((field, index)=>(
                  <TableRow key={paginationItemData.page*paginationItemData.rowsPerPage + index}>
                    <TableCell>
                      {field.name}
                    </TableCell>
                    <TableCell>
                      {parseDateFormat(field.date_time)?.split(',')[0]}
                    </TableCell>
                    <TableCell>
                      {numberFormatterWithDecimalAndThousand(field.amount_pending)}
                    </TableCell>
                    <AmountInput 
                      allSelected={allSelected} 
                      index={paginationItemData.page*paginationItemData.rowsPerPage + index} 
                      update={update} 
                      creditFields={creditFields} 
                      field={field} 
                      setValue={setValue}
                      getValues={getValues}
                    />
                  </TableRow>
                ))
              )}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25, 50]}
                  count={creditFields.length}
                  rowsPerPage={paginationItemData.rowsPerPage}
                  page={paginationItemData.page}
                  onPageChange={(e, number) => onPageItemChange(number)}
                  onRowsPerPageChange={(e) => onRowsPerPageItemChange(e)}
                  labelRowsPerPage={translate('ra.navigation.page_rows_per_page')}
                  labelDisplayedRows={({ from, to, count }) =>
                    `${from}–${to} ${translate('ra.navigation.of')} ${creditFields.length}`
                  }
                />
              </TableRow>
            </TableFooter>
        </Table>
        {/* {creditFields.length > 10 && <div style={{display:'flex', width:'100%', justifyContent:'center', alignItems:'center', marginTop:'15px'}}>
              <Button
                variant='outlined'
                onClick={
                  ()=>
                  {
                  setPartialCredits(prev=>[...prev, ...creditFields.slice(prev.length, prev.length + 10)])
                }}
              >
                {translate('ra.action.see_more')}
              </Button>
        </div>} */}
 
        </>
      )}
      <EditInputsWrap style={{marginTop:'30px'}} label={translate('ra.field.transaction_date')}>
          <DatePickers
            source={`date`}
            defaultValue={new Date()}
            validate={[required()]}
            viewsShow={false}
          />
      </EditInputsWrap>
    </>
  )
}